var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.rotation},[_c('VueBarcode',{attrs:{"value":_vm.barcode,"format":_vm.format===''? undefined :_vm.format,"width":"2","height":"80","font":"Times new roman","font-size":"12px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }